import React, {Fragment} from 'react';
import styled, {keyframes} from 'styled-components';
import {ClipLoader} from 'react-spinners';

const fadeUp = keyframes`
  from {
    opacity: 0;
    margin-top: 60px;
  }
  to {
    opacity: 1;
    margin-top: 0px;
  }
`;

export const Transition = styled.div`
  animation: ${fadeUp} 0.5s forwards 1;
  opacity: 0;
  margin-top: 60px;
`;

const PageTransition = ({loading,msg,children}) => {
  return (
    <Fragment>
      {loading ? (
        <div style={{textAlign:'center'}}>
          <ClipLoader
            color='blue'
            loading={loading}
          />
        {msg && <p>{msg}</p>}
        </div>
      ) : (
        <Transition>
          {children}
        </Transition>
      )}
    </Fragment>
  );
};

export default PageTransition;
